import React, { memo } from 'react';

import { LocationResultsListsV2Locations } from '../../components';
import { type LocationResultsListsV2Props } from '../../LocationResultsListsV2.types';

// ─────────────────────────────────────────────────────────────────────────────

export const LocationResultsListsV2SM = memo((props: LocationResultsListsV2SMProps) => {
  const {
    locationSearchActorRef,
    variation,
    interactedLocationRestaurantSlug,
    interactedLocationDeliveryAddressId,
  } = props;

  // ─────────────────────────────────────────────────────────────────────

  return (
    <LocationResultsListsV2Locations
      locationSearchActorRef={locationSearchActorRef}
      variation={variation}
      interactedLocationDeliveryAddressId={interactedLocationDeliveryAddressId}
      interactedLocationRestaurantSlug={interactedLocationRestaurantSlug}
    />
  );
});

// ─── Types ───────────────────────────────────────────────────────────────────

type LocationResultsListsV2SMProps = Omit<LocationResultsListsV2Props, 'isExpandedByDefault'>;
